import React from 'react'
import { useTranslation } from 'react-i18next'

import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import InputAdornment from '@material-ui/core/InputAdornment'

import LayerTooltip from './LayerToolTip'

const useStyles = makeStyles((theme) => ({
  selectIcon: {
    '& .MuiSelect-icon': {
      marginRight: theme.spacing(4),
    },
  },
}))

export const LayerSelector = ({
  layers,
  selectedLayer,
  handleSelectedLayer,
  width,
  disabled,
  className,
  hideLabel,
}) => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()

  return (
    <FormControl
      variant="standard"
      className={className}
      style={{ width: width ? width : 300 }}
    >
      {!hideLabel && (
        <InputLabel id="demo-simple-select-standard-label">
          {t('Layers')}
        </InputLabel>
      )}
      <Select
        className={classes.selectIcon}
        labelId={hideLabel ? undefined : 'demo-simple-select-standard-label'}
        id="demo-simple-select-standard"
        value={selectedLayer}
        onChange={(event) => {
          handleSelectedLayer(event, event.target.value)
        }}
        endAdornment={
          <InputAdornment position="end">
            <LayerTooltip layer={selectedLayer} marginLeft={1} />
          </InputAdornment>
        }
        translate="no"
      >
        {layers
          ?.filter((l) => l.is_sentinel || l.name.endsWith('WMS'))
          .map((option, index) => (
            <MenuItem key={option.id} value={option}>
              {i18n.exists(`Layer.${option.name}`) ? t(`Layer.${option.name}`) : option.displayed_name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  )
}
